module.exports = __webpack_public_path__ + "img/vignettes-asso_0001_anacaona.4e62f318.jpg";